var _circle, _circle2, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "#6B6B6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 20,
    y1: 12,
    x2: 22,
    y2: 12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 17.657,
    y1: 17.657,
    x2: 19.071,
    y2: 19.071
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 20,
    x2: 12,
    y2: 22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 6.343,
    y1: 17.657,
    x2: 4.929,
    y2: 19.071
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 4,
    y1: 12,
    x2: 2,
    y2: 12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 6.343,
    y1: 6.343,
    x2: 4.929,
    y2: 4.929
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 12,
    y1: 4,
    x2: 12,
    y2: 2
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 17.657,
    y1: 6.343,
    x2: 19.071,
    y2: 4.929
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminGear);
export default __webpack_public_path__ + "static/media/Admin_gear.9e9d5a5209d2a078a3de95ed8d1e9551.svg";
export { ForwardRef as ReactComponent };